export default __webpack_public_path__ + "9e1a4b0832ea2bab85fb1633df577f52.png";